// Lot 680 — titre de musique lisible : les titres issus d'un nom de fichier (« Aigle_Tabernacle___La_louange.mp3 »)
// sont un seul « mot » impossible à couper → `_` / `-` deviennent des espaces, l'extension disparaît, les espaces
// multiples sont réduits. Le texte peut alors revenir à la ligne naturellement dans la puce (stories, Reels, fil).
const AUDIO_EXT_RX = /\.(mp3|m4a|aac|wav|ogg|oga|flac|opus|weba|webm)$/i;

export const prettyMusicTitle = (title) => {
  const raw = String(title || "").trim();
  if (!raw) return "";
  return raw.replace(AUDIO_EXT_RX, "").replace(/[_]+/g, " ").replace(/\s*-\s*/g, " - ").replace(/\s{2,}/g, " ").trim();
};
